import { Route } from '@angular/router'
import { TaxonomyDetailComponent } from '../taxonomy-detail/taxonomy-detail.component'
import { createTaxonomyDefinition } from '../taxonomy-detail/taxonomy.definition'

import { PermissionGuard } from '../../abacus/guards/permission.guard'
import { AuthGuard } from '../../abacus/guards/auth.guard'

import { ApproachListComponent } from './approach-list/approach-list.component'

export const approachRoutes: Route[] = [
  {
    path: 'approaches',
    component: ApproachListComponent,
    canActivate: [AuthGuard, PermissionGuard],
    data: {
      permission: 'browseTaxonomies'
    }
  },
  {
    path: 'approaches/:id/edit',
    redirectTo: 'approaches/:id',
    pathMatch: 'full'
  },
  {
    path: 'approaches/:id',
    component: TaxonomyDetailComponent,
    canActivate: [AuthGuard, PermissionGuard],
    data: {
      definition: createTaxonomyDefinition({
        className: 'Approach',
        nameSingular: 'Approach',
        namePlural: 'Approaches',
        path: 'approaches',
        slug: 'taxonomies/approaches',
        title: 'Approaches'
      }),
      permission: 'readTaxonomies'
    }
  }
]
